<template>
<div>
<van-field
  readonly
  clickable
  :name="schema.name + '_' +schema.uniqid"
  :value="schema.value"
  :label="schema.label"
  placeholder="点击选择时间"
  :required="schema.required === true" 
  :rules="[{ required: schema.required === true ,message:'请选择'+schema.label}]"
  @click="onShowDtimePicker()"
/>

<van-popup v-model="showDtimePicker" position="bottom" >
  <van-datetime-picker
    title="点击选择"
    swipe-duration="300"
    :type="timePickerType"
    v-model="curDate"
    @confirm="onTimeConfirm"
    @cancel="showDtimePicker = false"
  />
</van-popup>
</div>
</template>

<script>
// import { Notify } from 'vant';

export default {
  name: 'datetime',
  props: {
    schema: {
      'type':Object,
      default:{},
      required:true
    },
    pluginIndex:{
      type:Number,
      default:0
    }
  },
  data:function(){
    var date = new Date();
    return {
      curDate:date,
      showDtimePicker:false,
      timePickerType:'datetime',
    }
  },
  methods:{
    onShowDtimePicker:function(){

      this.showDtimePicker = true;
      this.timePickerType = this.schema.type || 'datetime';

      var date = new Date();
      if(this.timePickerType=='time'){
        this.curDate = date.getHours() + ':' +  date.getMinutes();
      }else{
        this.curDate = date;
      }
      // console.log(index);

    },
    onTimeConfirm:function(time){

      console.log(time);

      var GMTToStr = function(time,type){

        if(type=='time'){
            return time;//时间可直接返回：如 12:30
        }

        let date = new Date(time);
        let Str = '';
        
        switch (type) {
          case 'datetime':
            let _getMinutes = date.getMinutes();
            if(_getMinutes<=9){
              _getMinutes = '0' + _getMinutes
            }
            Str = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' +  date.getDate() + '日 ' +  date.getHours() + ':' +  _getMinutes;
            break;
          case 'date':
            Str = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' +  date.getDate() + '日';
            break;
          case 'time':
            Str = time;
            break;
          case 'year-month':
            Str =  date.getFullYear() + '年' + (date.getMonth() + 1) + '月';
            break;
          case 'month-day':
            Str = (date.getMonth() + 1) + '月' +  date.getDate() + '日';
            break;
          default:
            break;
        }
        return Str
      }
      // console.log(this.timePickerType);
      this.showDtimePicker = false;
      this.schema.value = GMTToStr(time, this.timePickerType);
    }

    // onScan(){
    //   Notify({ type: 'warning', message: '点击了扫码',duration: 800 });
    // }
  }
}
</script>

<style>

</style>